export {
    getProfileDetails,
    setCandidateProfile,
    handlePoolStatusChange,
    setStatus,
    signOutCandidateProfile,
    updateCandidateProfileImage,
    setCandidateProfileImage
} from './candidateProfile';

export {
    getTalentPool,
    setTalentPool,
    viewCandidate,
    setJobTitle,
    getTalentPoolRecruiter,
    setCurrentRole,
    signOutTalentPool,
    clearTalentPoolRecruiter,
    setJobList,
    importCandidateRecruiter,
    removeCandidateRecruiter,
    viewCandidateRecruiter,
    setPermittedContact,
    setEditStatus,
    updateCandidatePublished,
    setCandidateCardProfileImage,
    setCandidateProfileEdit,
    setProgressNotification,
} from './talentPool';

export {
    getGroupedTalentPool,
    setGroupedTalentPool,
    handlePoolPriorityChange,
    signOutCandidateReview,
    setCandidateReviewProfileImage
} from './candidateReview';

export {
    getClientDetails,
    setClientDetails,
    signOutClientProfile,
    getProfileImage,
    updateProfileImage,
    getInterViewListCount,
    setInterViewListCount,
    setUploadButton,
    setPageDataLoss
} from './clientProfile';


// WEBPACK FOOTER //
// ./src/store/actions/index.js